var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sorils',_vm._b({attrs:{"categoryRefPath":_vm.$attrs.lesson.categoryRef.path,"allAssignments":false,"toCreate":false}},'Sorils',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }